import { Filters } from "@/types/filters";

export function areFiltersEqual(filters1: Partial<Filters>, filters2: Partial<Filters>): boolean {
	return JSON.stringify(filters1) === JSON.stringify(filters2);
}
